import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const PersonComputer = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="213" viewBox="0 0 306 213" width="306" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M206.03 212.25c54.25 0 98.23-4.6 98.23-10.28s-43.98-10.28-98.23-10.28-98.23 4.6-98.23 10.28 43.98 10.28 98.23 10.28Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M233.59 197.55H26.95a2.7 2.7 0 0 0-2.69 2.69v3.72c0 1.49 1.2 2.69 2.69 2.69h206.64c1.49 0 2.69-1.2 2.69-2.69v-3.72c0-1.49-1.2-2.69-2.69-2.69Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path d="M110.32 35.43a8.28 8.28 0 1 0 0-16.56 8.28 8.28 0 0 0 0 16.56Z" fill={shades.white} />
      <path
        className={strokeStyle}
        d="M291.01 197.65h-14.63l-10.46-23.85c-5.57 12.38-18.02 20.05-36.12 23.85h-3.03l-55.93-23.75-28.76-12.61a471 471 0 0 1 11.81-17.76c10.45-14.98 22.34-30 34.77-41.97 9.57 5.88 39.3-11.43 38.1-23.64a37 37 0 0 1 9.24-.87c22.87.84 39.48 24.21 51.07 51.24 7.69 17.93 13.18 37.48 16.84 53.14a13.23 13.23 0 0 1-12.9 16.22Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M181.49 155.07a17.5 17.5 0 0 0-4.61 6.32l-8.43 6.73-6.47 1.6 2.99-5.96 11.33-9.04c2.15.56 4.69.4 5.2.36z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M233.39 173.21a80 80 0 0 1-6.62 24.44h-1.78l-54.15-23.75a25 25 0 0 1 4.42-3.76c-.08-3.21.5-6.17 1.63-8.76a17.6 17.6 0 0 1 4.61-6.32c-.51.04-3.05.2-5.2-.35-1.11-.29-2.12-.77-2.68-1.57-.83-1.17 2.95-13.11 14.75-17.98a21 21 0 0 1 8.54-1.58c1.64-3.75 5.22-8.69 12.85-9.44a16.4 16.4 0 0 1 8.86 1.67c1.93 1.04 8.04 5.79 11.17 13.44 3.42 8.33 3.8 19.77 3.91 25.12.06 3-.02 5.99-.31 8.83z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M175.25 170.14c7.94-5.28 17.94-4.99 27.58-.33" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M189.89 151c5.38-1.11 11.87-.23 18.84 3.32" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M181.49 155.07a18.5 18.5 0 0 1 8.4-4.07" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M229.25 118.29c0 .79-.34 1.56-.98 2.07l-8.17 6.52-11.68 9.32a34 34 0 0 0-6.39-2.04l12.2-9.74 10.56-8.43a2.73 2.73 0 0 1 3.83.51c.42.53.63 1.16.63 1.78z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M212.39 138.24c-4.64-2.94-9.88-4.28-15.49-4.66" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M276.37 197.66h-46.59c18.11-3.8 30.55-11.47 36.13-23.86z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M213.76 82.74c-8.44 4.35-16.89 10.92-25.1 18.82-12.44 11.97-24.32 26.99-34.78 41.97-6.11-4.28-11.98-8.64-15.08-13.92 0 0 8.48 5.98 17.7-5.53a24.3 24.3 0 0 0 5.45-18.22c3.28-3.12 7.45-8.16 7.96-13.98 15.5.09 30.23-2.55 43.85-9.14Z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M156.5 124.08c-9.22 11.51-17.7 5.53-17.7 5.53a15.5 15.5 0 0 1-2.27-8.44c7.73 2.47 15.21 1.58 21.39-11.96 0 0 1.81-1.23 4.03-3.34.5 4.51 0 11.41-5.45 18.22z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M188.66 101.57c8.21-7.9 16.66-14.48 25.1-18.82q.02 0 .03-.02l1.59-.79.08-.04a51 51 0 0 1 11.3-3.98c1.22 12.21-28.52 29.51-38.09 23.64z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M191.34 197.66h-48.89l14.05-15.76z" fill={shades.primary.medium} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m135.27 172.29 15.32 6.93-8.13 18.44c-9.32-.11-16.27-8.64-7.19-25.36z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M230.02 132.39q11.24-9.15 14.91-25.02" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M233.69 164.39c-.21-10.25-2.15-20.55-3.67-24.52a32 32 0 0 0-2.69-5.46q1.39-.96 2.69-2.02c8.36 2.39 8.13 13.58 3.67 32Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M269.19 158.97a40 40 0 0 1-3.27 14.82c-5.42 12.05-17.35 19.64-34.66 23.54q-1.46.33-2.95.32h-1.54"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M155.03 78.69c-4.12-.06-8.56.62-12.47 1.74l-1.27.38a27 27 0 0 0-7.43 3.48l-4.8-5.35c-2.88 1.91-6.21 3.77-9.22 4.63-2.15.61-4.15.71-5.71-.05-3.51-1.71-6.36-6.59-3.14-12.31 0 0 1.7 6.1 8.35 3.07 6.65-3.04-1.03-9.88-1.03-9.88 7.4-3.74 17.35-3.38 20.48-2.01 5.35 2.34 12.16 10.76 16.23 16.31z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M119.35 74.28c-6.65 3.04-8.35-3.07-8.35-3.07a17.4 17.4 0 0 1 7.33-6.81s7.68 6.85 1.03 9.88z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M140.88 117.33a6.3 6.3 0 0 1-4.34 3.54 10.3 10.3 0 0 1-10.38-3.53c-2.76-3.4-2.45-6.08-1.61-7.8 1.95 2.71 5.61 5.04 9.53 6.43 2.26.8 4.62 1.29 6.79 1.36z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M143.72 99.95a6.8 6.8 0 0 1-4.92 4.38c-4.29.98-10.41-.6-14.8-3.76a16 16 0 0 1-3.58-3.51c-4.04-5.64-2.5-10.48-.58-13.5 3.01-.86 6.34-2.72 9.22-4.63l4.8 5.35c-1.17.84-2 1.73-2.39 2.61-1.57 3.58-.83 6.65 1.33 8.94a13.5 13.5 0 0 0 5.92 3.41q1.1.33 2.28.54 1.28.22 2.71.18z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M148.98 113.76c-.99 1.89-2.85 2.96-5.14 3.37.46-.47 1.4-1.74.64-3.72-.98-2.55-3.69-3.78-7.95-1.93s-2.44 4.49-2.44 4.49c-3.93-1.39-7.58-3.72-9.53-6.43l-.23-.33c-2.68-4.06-1.66-6.93-.32-8.63 4.39 3.15 10.5 4.74 14.8 3.76a6.8 6.8 0 0 0 4.92-4.38c.17.13 8.96 6.72 5.26 13.81z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M143.84 117.13q-1.39.25-2.96.19a23 23 0 0 1-6.79-1.36s-1.83-2.65 2.44-4.49 6.98-.62 7.95 1.93a3.35 3.35 0 0 1-.64 3.72z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M169.91 91.88c-.51 5.83-4.68 10.87-7.96 13.98a36 36 0 0 1-4.03 3.34c-6.17 13.55-13.66 14.43-21.39 11.96l.01-.3a6.3 6.3 0 0 0 4.34-3.54q1.56.05 2.96-.19c2.29-.42 4.16-1.48 5.14-3.37 3.7-7.09-5.08-13.68-5.26-13.81q-1.43.05-2.71-.18-1.19-.21-2.28-.54a13.4 13.4 0 0 1-5.92-3.41c-2.16-2.28-2.91-5.36-1.33-8.94a7 7 0 0 1 2.39-2.61s1.8 7.04 7.11 8.44c2.63.7 7.4-3.04 7.4-6.94 0-3.39-4.62-5-5.81-5.36a44 44 0 0 1 12.47-1.74c6.04.08 11.42 1.77 13.51 6.02a13.4 13.4 0 0 1 1.37 7.17z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M129.06 78.93c4.2-2.78 7.46-5.66 7.46-5.66" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M143.72 99.95c7.27-.2 16.69-4.96 16.69-4.96" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M148.38 85.79c0 3.89-4.77 7.64-7.4 6.94-5.31-1.41-7.11-8.44-7.11-8.44a28 28 0 0 1 7.43-3.48l1.27-.38c1.2.36 5.82 1.97 5.81 5.36Z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        d="M189.77 51.54q-2.54.26-4.97.29a118 118 0 0 1-8.38-23.56c3.95 1.32 8.24 2.48 12.94 3.69a21 21 0 0 0-2.16 8.67c-.14 4.02.82 7.79 2.58 10.91z"
        fill={shades.white}
      />
      <path
        d="m179.54 51.64-.16-.02q-4.67-.45-8.96-1.98a33 33 0 0 1-4.01-1.75l-.07-.03a36 36 0 0 1-7.42-5.15c-1.45-5.75-1.46-11.15.19-16.16q.9-2.76 2.48-5.34a44 44 0 0 0 7.93 4.42 91 91 0 0 0 10.02 26.01Z"
        fill={shades.white}
      />
      <path
        d="M184.8 51.83q-2.68.05-5.26-.2a91 91 0 0 1-10.02-26.01q3.25 1.44 6.89 2.64c1.75 7.48 4.47 15.3 8.38 23.56z"
        fill={shades.primary.light}
      />
      <path
        className={strokeStyle}
        d="M194.34 25.72a18.5 18.5 0 0 0-4.98 6.24c-4.7-1.21-9-2.37-12.94-3.69a78 78 0 0 1-6.89-2.64 60 60 0 0 1-3.21-1.55 32 32 0 0 1 4.45-7.96l.35.44c1.19 1.37 12.55 6.75 23.21 9.17z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M204.26 61.36a25.6 25.6 0 0 1-17.18 3.61c-9.56-1.41-17.15-8.14-20.74-17.12l.07.03q1.96 1.02 4.01 1.75a37 37 0 0 0 9.12 2q2.57.24 5.25.2 2.43-.05 4.97-.29a16.6 16.6 0 0 0 9.37 7.88l3.23 1.28.59.23q.65.24 1.31.43Z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M214.18 42.71c-.1 2.85-2.19 5.08-4.66 5s-4.4-2.47-4.3-5.31c.1-2.85 2.18-5.09 4.66-5s4.4 2.47 4.3 5.31Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M213.34 25.02q-.48-.18-.97-.32v-.06z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m219.72 27.85-1.33.25-.11-.09a16 16 0 0 0-4.62-2.86l-.32-.12-.98-.38a43 43 0 0 0-4.1-13.82 23 23 0 0 0-4.35-6.04c5.34 1.14 9.64 2.91 11.15 5.31 3.93 6.26 10.31 16.59 4.66 17.77z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M213.34 25.02q-.48-.18-.97-.32v-.06z" fill={shades.white} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="m218.4 28.1-.09.01-.02-.11z" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M167.94 20.51a31 31 0 0 0-1.62 3.56 44 44 0 0 1-4.72-2.87c1.89-.7 3.99-.96 6.34-.69Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M189.77 51.54a61 61 0 0 1-4.97.3 48 48 0 0 1-5.26-.2l-.16-.02q-4.67-.45-8.96-1.98a35 35 0 0 1-11.5-6.94c-1.45-5.75-1.46-11.15.18-16.16q.9-2.76 2.49-5.35a43 43 0 0 0 4.72 2.87q1.56.82 3.21 1.56 3.25 1.44 6.89 2.64c3.94 1.32 8.24 2.49 12.95 3.7a21 21 0 0 0-2.17 8.66c-.14 4.02.82 7.79 2.57 10.91z"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M212.37 24.64v.06q-.57-.17-1.16-.29a14.5 14.5 0 0 0-15.95.62c.05-10.85-1.69-17.09-4.76-19.93a7 7 0 0 0-4.13-1.84 10 10 0 0 0-2.54.11s5.77-4.18 14.28-1.98c2.18.57 4.11 1.75 5.8 3.38a23 23 0 0 1 4.35 6.04 43 43 0 0 1 4.1 13.82z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M195.26 25.03q-.47.33-.93.69c-10.66-2.41-22.02-7.8-23.21-9.17q-.18-.2-.35-.44c-2.45-3.23-3.88-9.63 6.53-11.91 1.87-.41 4.1-.69 6.52-.84a69 69 0 0 1 2.54-.11q2.34.2 4.13 1.84c3.06 2.84 4.81 9.08 4.76 19.93z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M214.18 42.71c-.1 2.85-2.19 5.08-4.66 5s-4.4-2.47-4.3-5.31c.1-2.85 2.18-5.09 4.66-5s4.4 2.47 4.3 5.31Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m218.4 28.1-.09.01-.02-.11z" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M211.21 24.41q-1.14-.23-2.34-.27c-3.28-.11-6.38.89-9.01 2.71-4.62 3.2-7.8 8.93-8.04 15.57-.26 7.52 3.33 14.14 8.75 17.36q.87.52 1.79.91l-3.23-1.28a16.6 16.6 0 0 1-9.37-7.88 21 21 0 0 1-2.58-10.91c.11-3.15.89-6.1 2.16-8.67a18.6 18.6 0 0 1 5.91-6.93 14.8 14.8 0 0 1 8.98-2.69c2.52.09 4.88.83 6.97 2.07z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M214.18 42.71c-.1 2.85-2.19 5.08-4.66 5s-4.4-2.47-4.3-5.31c.1-2.85 2.18-5.09 4.66-5s4.4 2.47 4.3 5.31Zm4.22-14.61-.09.01-.02-.11a16 16 0 0 0-4.62-2.86l-.32-.12a16 16 0 0 0-2.13-.61q-1.14-.24-2.34-.28c-3.28-.11-6.38.89-9.01 2.71-4.62 3.2-7.8 8.93-8.04 15.57-.26 7.52 3.33 14.14 8.75 17.36q.86.51 1.79.91l.59.23q.65.24 1.31.43 1.59.44 3.28.5c9.05.32 16.68-7.87 17.04-18.29.22-6.26-2.24-11.9-6.19-15.48z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M214.18 42.71c-.1 2.85-2.19 5.08-4.66 5s-4.4-2.47-4.3-5.31c.1-2.85 2.18-5.09 4.66-5s4.4 2.47 4.3 5.31Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M214.18 42.71c-.1 2.85-2.19 5.08-4.66 5s-4.4-2.47-4.3-5.31c.1-2.85 2.18-5.09 4.66-5s4.4 2.47 4.3 5.31Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m212.53 24.7-3.61-1.4" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m156.5 181.9-17.37 19.49c-.4.45-.98.71-1.59.7l-5.5-.06c-1.8-.02-2.74-2.15-1.42-.94l19.15-22.22z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M100.29 143.66 80.83 159.7l-28.68 23.64-1.45 1.2-9.41 7.76-6.5 5.35h-4.82c-.86 0-1.25-1.08-.58-1.62l11.9-9.81 3.71-3.06 5.91-4.87 23.94-19.74 22.12-18.23 3.33 3.33z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m80.83 159.7-28.68 23.64-1.45 1.2a24 24 0 0 1-5.71-1.38l5.91-4.87 23.94-19.74c2.08.08 4.11.47 5.99 1.14z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M34.78 197.66h51.44" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M236.28 206.31h-21.24c-3.01 0-5.99-.64-8.74-1.88l-49.81-22.53-7.96-3.6-13.27-6-21.04-9.52a3.05 3.05 0 0 1-.65-5.17l4.57-3.65a5.4 5.4 0 0 1 5.55-.73l18.37 8.06 28.76 12.61 66.16 29.02c1.75.77 1.2 3.38-.71 3.38z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M110.88 197.47v3.29c0 1.48-1.2 2.68-2.68 2.68H47.65c-1.21 0-1.73-1.54-.77-2.28l4.79-3.69z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M95.15 185.82h-7.79v11.65h7.79z" fill={shades.white} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M87.36 185.82h-7.79v11.65h7.79z" fill={shades.white} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M79.58 185.82h-7.79v11.65h7.79z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M71.79 185.82v11.65H51.68l14.24-10.97a3.3 3.3 0 0 1 2-.68z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M110.88 189.1v8.37H95.15v-11.65h12.45a3.3 3.3 0 0 1 3.28 3.28Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        d="m108.56 143.74-2.17 2.17a4.24 4.24 0 0 1-6 0l-43.12-43.13a8.7 8.7 0 0 1-2.56-6.14l-.3-55.24c.32-4.97 1.54-7.3 3.59-8.72l3.4-2.35a2.64 2.64 0 0 1 4.14 2.17v60.88c0 1.52.6 2.98 1.68 4.05l41.34 41.34a3.5 3.5 0 0 1 0 4.96z"
        fill={shades.white}
      />
      <path d="M91.03 45.51v8.45" stroke={shades.primary.medium} strokeWidth={strokeWidth} />
      <path d="M95.25 49.74H86.8" stroke={shades.primary.medium} strokeWidth={strokeWidth} />
      <path d="M110.32 23.65v7.01" stroke={shades.primary.medium} strokeWidth={strokeWidth} />
      <path d="M113.18 27.15h-5.72" stroke={shades.primary.medium} strokeWidth={strokeWidth} />
      <path
        d="M45.95 150s-4.45-7.27-24-4.76-23.7 11.91-7.02 15.16c0 0-18.92 2.38-14.16 11.15s36.84-1.6 36.84-1.6 9.77 8.12 19.8 6.24 13.91-6.24 13.91-6.24 14.63 8.74 19.16-1.66-4.5-17.67-14.27-17.92-13.65 4.14-13.65 4.14.61-7.02-5.78-10.03-10.84 5.51-10.84 5.51z"
        fill={shades.white}
      />
      <path
        d="m296.29 41.88-5.37 3.59c-.82.55-.98 1.7-.34 2.45l1.01 1.19 2.56 3.03c.41.48.3 1.21-.23 1.56l-5.77 3.75c-.7.46-1.63.32-2.17-.32l-2.3-2.72-1.71-2.03a.86.86 0 0 0-1.13-.16l-6.2 4.15c-.92.61-2.16.12-2.41-.96l-7.06-31.03a1.66 1.66 0 0 1 2.45-1.79l28.58 16.46a1.66 1.66 0 0 1 .1 2.82z"
        fill={shades.white}
      />
    </svg>
  );
};
